// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Translation resources
const resources = {
  en: {
    translation: {
      navbar: {
        homepage: "Homepage",
        direction: "Direction",
        myBooking: "My Booking",
        register: "Register",
        login: "Login",
        profile: "Profile",
        admin_panel: "Admin Panel",
        logout: "Logout",
      },
      room: {
        max_adults: "Max Adults",
        max_children: "Max Children",
        extra_bed: "Extra Bed",
        facilities: "Facilities",
        smoking_policy: "Smoking Allowed",
        no_smoking: "No Smoking",
        view: "View",
        bedding: "Bedding",
        room_size: "Room Size",
        room_type: "Room Type",
        average_rating: "Average Rating",
        rate_this_room: "Rate this Room",
        submit_rating: "Submit Rating",
        description: "Description",
        details: "View Details",
        rate_plan: "Rate Plan",
        meal_plan: "Meal Plan",
        cancellation_policy: "Cancellation Policy",
        pick: "Pick",
        add_on_services: "Add-on Services",
        more_info: "More Info",
        service_name: "Service Name",
        service_type: "Service Type",
        charge_type: "Charge Type",
        price: "Price",
        date_applied: "Date Applied",
        close: "Close",
        validate: "Validate",
        booking_id: "Booking ID",
        guest_name: "Guest Name",
        rate_the_room: "Rate the Room",
        your_review: "Your Review",
        pick_addon_service: "Pick Add-on Service",
        addon_service: {
          description: "Description",
        },
      },
      homescreen: {
        check_in: "Check-in",
        check_out: "Check-out",
        adults: "Adults",
        children: "Children",
        promo_code: "Promo Code",
        apply: "Apply",
        loading: "Loading...",
        total_nights: "No of night",
        no_of_room: "No. of Rooms",
        your_bookings: "YOUR BOOKINGS",
        grand_total: "Grand Total",
        continue_checkout: "Continue to Checkout",
        open_sidebar: "Open Sidebar",
        add_on_service: "Add-On Service",
        quantity: "Quantity",
        room_rate: "Room Rate",
        rate_plan: "Rate Plan",
        room: "Room",
        extra_bed: "Extra Bed",
        yes: "Yes",
        no: "No",
        view_add_on_services: "View our Add-on Services",
        extra_bed_fee: "Extra Bed Fee",
      },
      filter_room: {
        guests: "Guests",
        Check_in: "Check-in",
        Check_out: "Check-out",
        adults: "Adults",
        children: "Children",
        children_under_age: "Children under {{age}} years old",
        cancel: "Cancel",
        save: "Save",
        children_policy: "Children Policy",
        children_policy_text: `<ul style="padding-left:0;margin-bottom:0;list-style:none;">
            <li style="margin-bottom:8px;">
              Children from <strong>1–{{childrenFreeAge}} years old</strong> stay free of charge. Baby cots are on request and subject to availability.
            </li>
            <li style="margin-bottom:8px;">
              Children from <strong>{{childrenFreeAgePlusOne}} years old to {{childrenMaxAge}} years old</strong> are qualified for an extra bed at <strong>VND {{childrenExtraPrice}} net extra price per night</strong> inclusive daily breakfast. Maximum an extra bed per room.
            </li>
            <li>
              Children <strong>{{childrenMaxAgePlusOne}} years old and up</strong> are charged the same rate as adults.
            </li>
          </ul>`,
        child_age: "{{number_of_children}} child's age",
        years_old: "years old",
      },
      footer: {
        legal: "Legal",
        help: "Help",
        cookie_settings: "Cookie Settings",
        terms_of_service: "Terms of Service",
        privacy_policy: "Privacy Policy",
        support: "Support",
        sign_up: "Sign Up",
        sign_in: "Sign In",
        contact_us: "Contact Us",
        follow_us: "Follow Us",
        all_rights_reserved: "All rights reserved.",
      },
      guest_information: {
        guest_information: "Guest Information",
        guest_name: "Guest Name",
        email_address: "Email Address",
        confirm_email_address: "Confirm Email Address",
        phone_number: "Phone Number",
        confirm_phone_number: "Confirm Phone Number",
        nationality: "Nationality",
        special_requests: "Special Requests",
        enter_your_name: "Enter your name",
        enter_your_email: "Enter your email",
        enter_your_phone: "Enter your phone number",
        confirm_your_email: "Confirm your email",
        confirm_your_phone: "Confirm your phone number",
        any_special_requests: "Any special requests?",
        enter_valid_email: "Please enter a valid email address.",
        email_must_match: "Email addresses must match.",
        phone_must_match: "Phone numbers must match.",
        select_nationality: "Select your nationality",
        email_confirmation_not_match: "Email confirmation does not match.",
        phone_confirmation_not_match:
          "Phone number confirmation does not match.",
        require_all_fields: "All guest information fields are required.",
        no_booking_available:
          "No booking details available. Please select a room and rate plan.",
        title: "Guest Details",
        email: "Email",
      },
      booking: {
        check_in: "Check-in",
        check_out: "Check-out",
        total_nights: "Total Nights",
        your_booking_details: "Your Booking Details",
        addon_services: "Add-on Services",
        grand_total: "Grand Total",
        total_pay: "Total You Pay In VND",
        pay_at_hotel: "You will pay upon arrival at the hotel.",
        secure_type: "Your payment is secured with:",
        confirm_to_leave: "Are you sure you want to leave?",
        go_back_discard: "Going back will discard your booking details.",
        confirm_booking: "Yes, leave",
        cancel: "Stay",
        success_message: "Your reservation was booked successfully",
        success: "Success",
        OK: "OK",
        confirm_policy:
          "I confirm that I am of legal age and agree to the Hotel",
        term_conditions: "Terms & Conditions",
        detail: {
          rate_plan: "Rate Plan",
          meal_plan: "Meal Plan",
          number_of_rooms: "Number of Rooms Booked",
          adults: "Adults",
          children: "Children",
          total_rate: "Total Rate",
          extra_bed_price: "Extra Bed Price",
          cancellation_policy: "Cancellation Policy",
        },
        add_on_service: {
          service_name: "Service Name",
          description: "Description",
          service_price: "Service Price",
          not_added: "No add-on services selected.",
        },
        confirmation: {
          title: "Booking Confirmation",
          booking_id: "Booking ID",
          transaction_id: "Transaction ID",
          payment_method: "Payment Method",
          check_in_date: "Check-in Date",
          check_out_date: "Check-out Date",
          total_nights: "Total Nights",
          grand_total: "Grand Total",
          email: "Email",
          policy_service: `All prices are quoted in VND, inclusive of 5% service charge and
              10% Tax (VAT).`,
          scan_booking: "Scan to manage booking",
          read_rule_hotel: "Read Our Hotel Rules",
          view_on_map: "View on Map",
          download_booking: "Download Booking",
          add_to_calendar: "Add to Calendar",
          thank_you: "Thank you for booking with us!",
          room_detail: {
            title: "Room Details",
            number_of_rooms: "Number of Rooms",
            rate_plan: "Rate Plan",
            rate: "Rate",
            adults: "Adults",
            children: "Children",
            extra_bed: "Extra Bed",
            cancellation_policy: "Cancellation Policy",
            total_extra_bed_price: "Total Extra Bed Price",
            no_data: "No room details available.",
          },
          rate_breakdown: {
            title: "Rate Breakdown",
            date: "Date",
            original_rate: "Original Rate",
            promotion: "Promotion",
            promotion_discount: "Promotion Discount",
            promo_code: "Promo Code",
            final_rate: "Final Rate",
            no_data: "No rate breakdown available.",
          },
        },
        children_age_policy: {
          title: "Children Age Policy",
          description:
            "The extra bed charge for children is not included in the total booking price. This fee is payable upon arrival at the hotel.",
          extra_bed_price: "Extra Bed Price",
        },
      },
    },
  },
  vi: {
    translation: {
      navbar: {
        homepage: "Trang chủ",
        direction: "Chỉ đường",
        myBooking: "Đặt Phòng Của Tôi",
        register: "Đăng ký",
        login: "Đăng nhập",
        profile: "Hồ sơ",
        admin_panel: "Quản Lý",
        logout: "Đăng xuất",
      },
      room: {
        max_adults: "Số người lớn tối đa",
        max_children: "Số trẻ em tối đa",
        extra_bed: "Giường phụ",
        facilities: "Tiện nghi",
        smoking_policy: "Cho phép hút thuốc",
        no_smoking: "Không hút thuốc",
        view: "Hướng nhìn",
        bedding: "Loại Giường",
        room_size: "Diện tích phòng",
        room_type: "Loại phòng",
        rate_this_room: "Đánh giá phòng",
        submit_rating: "Gửi đánh giá",
        average_rating: "Điểm đánh giá",
        description: "Mô tả phòng",
        details: "Xem Chi Tiết",
        rate_plan: "Gói giá",
        meal_plan: "Kế hoạch bữa ăn",
        cancellation_policy: "Chính sách hủy",
        pick: "Chọn",
        add_on_services: "Dịch vụ bổ sung",
        more_info: "Thêm thông tin",
        service_name: "Tên dịch vụ",
        service_type: "Loại dịch vụ",
        charge_type: "Hình thức tính phí",
        price: "Giá",
        date_applied: "Ngày áp dụng",
        close: "Đóng",
        validate: "Xác thực",
        booking_id: "Mã đặt phòng",
        guest_name: "Tên khách",
        rate_the_room: "Đánh giá phòng",
        your_review: "Đánh giá của bạn",
        pick_addon_service: "Chọn dịch vụ bổ sung",
        addon_service: {
          service_name: "Tên dịch vụ",
          description: "Mô tả",
          service_type: "Loại dịch vụ",
          charge_type: "Hình thức tính phí",
          price: "Giá",
          date_applied: "Ngày áp dụng",
        },
      },
      homescreen: {
        check_in: "Ngày nhận phòng",
        check_out: "Ngày trả phòng",
        adults: "Người lớn",
        children: "Trẻ em",
        promo_code: "Mã khuyến mãi",
        apply: "Tìm",
        loading: "Đang tải...",
        total_nights: "Số Đêm Ở",
        no_of_room: "Số Phòng",
        your_bookings: "ĐẶT PHÒNG CỦA BẠN",
        grand_total: "Tổng cộng",
        continue_checkout: "Thanh toán",
        open_sidebar: "Mở Cổng Thanh Toán",
        add_on_service: "Dịch vụ Bổ Sung",
        quantity: "Số lượng",
        room_rate: "Giá phòng",
        rate_plan: "Gói Giá",
        room: "Phòng",
        extra_bed: "Giường phụ",
        yes: "Có",
        no: "Không",
        view_add_on_services: "Xem dịch vụ bổ sung",
        extra_bed_fee: "Phí giường phụ",
      },
      filter_room: {
        guests: "Số lượng khách",
        Check_in: "Ngày nhận phòng",
        Check_out: "Ngày trả phòng",
        adults: "Người lớn",
        children: "Trẻ em",
        children_under_age: "Trẻ dưới {{age}} tuổi",
        cancel: "Hủy",
        save: "Lưu",
        children_policy: "Chính sách trẻ em",
        children_policy_text: `<ul style="padding-left:0;margin-bottom:0;list-style:none;"> <li style="margin-bottom:8px;"> Trẻ từ <strong>1–{{childrenFreeAge}} tuổi</strong> được ở miễn phí. Nôi trẻ em có thể yêu cầu và tùy thuộc vào tình trạng sẵn có. </li> <li style="margin-bottom:8px;"> Trẻ từ <strong>{{childrenFreeAgePlusOne}} đến {{childrenMaxAge}} tuổi</strong> được kê thêm giường phụ với <strong>{{childrenExtraPrice}} VND mỗi đêm</strong> đã bao gồm bữa sáng. Tối đa một giường phụ mỗi phòng. </li> <li> Trẻ <strong>từ {{childrenMaxAgePlusOne}} tuổi trở lên</strong> tính như người lớn. </li> </ul>`,
        child_age: "tuổi của {{number_of_children}} trẻ",
        years_old: "tuổi",
      },
      footer: {
        legal: "Pháp lý",
        help: "Trợ giúp",
        cookie_settings: "Cài đặt Cookie",
        terms_of_service: "Điều khoản dịch vụ",
        privacy_policy: "Chính sách bảo mật",
        support: "Hỗ trợ",
        sign_up: "Đăng ký",
        sign_in: "Đăng nhập",
        contact_us: "Liên hệ chúng tôi",
        follow_us: "Theo dõi chúng tôi",
        all_rights_reserved: "Đã đăng ký bản quyền.",
      },
      guest_information: {
        guest_information: "Thông tin khách",
        title: "Chi tiết khách",
        email: "Email",
        guest_name: "Tên khách",
        email_address: "Địa chỉ email",
        confirm_email_address: "Xác nhận email",
        phone_number: "Số điện thoại",
        confirm_phone_number: "Xác nhận số điện thoại",
        nationality: "Quốc tịch",
        special_requests: "Yêu cầu đặc biệt",
        enter_your_name: "Nhập tên của bạn",
        enter_your_email: "Nhập email của bạn",
        enter_your_phone: "Nhập số điện thoại của bạn",
        confirm_your_email: "Xác nhận email của bạn",
        confirm_your_phone: "Xác nhận số điện thoại của bạn",
        any_special_requests: "Có yêu cầu đặc biệt nào không?",
        enter_valid_email: "Vui lòng nhập địa chỉ email hợp lệ.",
        email_must_match: "Địa chỉ email phải trùng khớp.",
        phone_must_match: "Số điện thoại phải trùng khớp.",
        select_nationality: "Chọn quốc tịch của bạn",
        email_confirmation_not_match: "Xác nhận email không khớp.",
        phone_confirmation_not_match: "Xác nhận số điện thoại không khớp.",
        require_all_fields: "Tất cả các trường thông tin khách đều bắt buộc.",
        no_booking_available:
          "Không có chi tiết đặt phòng. Vui lòng chọn phòng và gói giá.",
      },
      booking: {
        check_in: "Ngày nhận phòng",
        check_out: "Ngày trả phòng",
        total_nights: "Tổng số đêm",
        your_booking_details: "Chi tiết đặt phòng của bạn",
        addon_services: "Dịch vụ bổ sung",
        grand_total: "Tổng cộng",
        total_pay: "Tổng số tiền bạn trả (VND)",
        pay_at_hotel: "Bạn sẽ thanh toán khi đến khách sạn.",
        secure_type: "Thanh toán của bạn được bảo mật với:",
        confirm_to_leave: "Bạn có chắc chắn muốn rời đi?",
        go_back_discard: "Quay lại sẽ hủy chi tiết đặt phòng.",
        confirm_booking: "Có, rời đi",
        cancel: "Ở lại",
        success_message: "Đặt phòng của bạn đã thành công",
        success: "Thành công",
        OK: "OK",
        confirm_policy: "Tôi xác nhận đủ tuổi hợp pháp và đồng ý với",
        term_conditions: "Điều khoản & Điều kiện của Khách sạn",
        detail: {
          rate_plan: "Gói giá",
          meal_plan: "Kế hoạch bữa ăn",
          number_of_rooms: "Số phòng đã đặt",
          adults: "Người lớn",
          children: "Trẻ em",
          total_rate: "Tổng giá",
          extra_bed_price: "Giá giường phụ",
          cancellation_policy: "Chính sách hủy",
        },
        add_on_service: {
          service_name: "Tên dịch vụ",
          description: "Mô tả",
          service_price: "Giá dịch vụ",
          not_added: "Chưa chọn dịch vụ bổ sung nào.",
        },
        confirmation: {
          title: "Xác nhận đặt phòng",
          booking_id: "Mã đặt phòng",
          transaction_id: "Mã giao dịch",
          payment_method: "Phương thức thanh toán",
          check_in_date: "Ngày nhận phòng",
          check_out_date: "Ngày trả phòng",
          total_nights: "Tổng số đêm",
          grand_total: "Tổng cộng",
          email: "Email",
          policy_service:
            "Tất cả giá đã bao gồm 5% phí dịch vụ và 10% thuế VAT.",
          scan_booking: "Quét để quản lý đặt phòng",
          read_rule_hotel: "Xem nội quy khách sạn",
          view_on_map: "Xem trên bản đồ",
          download_booking: "Tải đặt phòng",
          add_to_calendar: "Thêm vào lịch",
          thank_you: "Cảm ơn bạn đã đặt phòng với chúng tôi!",
          room_detail: {
            title: "Chi tiết phòng",
            number_of_rooms: "Số phòng",
            rate_plan: "Gói giá",
            rate: "Giá",
            adults: "Người lớn",
            children: "Trẻ em",
            extra_bed: "Giường phụ",
            cancellation_policy: "Chính sách hủy",
            total_extra_bed_price: "Tổng giá giường phụ",
            no_data: "Không có thông tin phòng.",
          },
          rate_breakdown: {
            title: "Chi tiết giá",
            date: "Ngày",
            original_rate: "Giá gốc",
            promotion: "Khuyến mãi",
            promotion_discount: "Giảm giá khuyến mãi",
            promo_code: "Mã khuyến mãi",
            final_rate: "Giá cuối cùng",
            no_data: "Không có chi tiết giá.",
          },
        },
        children_age_policy: {
          title: "Chính sách độ tuổi trẻ em",
          description:
            "Phí giường phụ cho trẻ em không bao gồm trong tổng giá đặt phòng. Khoản phí này sẽ được thanh toán khi đến khách sạn.",
          extra_bed_price: "Giá giường phụ",
        },
      },
    },
  },
  ko: {
    translation: {
      navbar: {
        homepage: "홈페이지",
        direction: "길 찾기",
        myBooking: "내 예약",
        register: "회원가입",
        login: "로그인",
        profile: "프로필",
        admin_panel: "관리자 패널",
        logout: "로그아웃",
      },
      room: {
        max_adults: "최대 성인 수",
        max_children: "최대 어린이 수",
        extra_bed: "추가 침대",
        facilities: "시설",
        smoking_policy: "흡연 가능",
        no_smoking: "금연",
        view: "전망",
        bedding: "침구",
        room_size: "방 크기",
        room_type: "방 유형",
        rate_this_room: "이 방 평가하기",
        submit_rating: "평가 제출",
        description: "설명",
        average_rating: "평균 평점",
        details: "자세히 보기",
        rate_plan: "요금제",
        meal_plan: "식사 계획",
        cancellation_policy: "취소 정책",
        pick: "선택",
        add_on_services: "추가 서비스",
        more_info: "추가 정보",
        service_name: "서비스 이름",
        service_type: "서비스 유형",
        charge_type: "요금 유형",
        price: "가격",
        date_applied: "적용 날짜",
        close: "닫기",
        validate: "확인",
        booking_id: "예약 ID",
        guest_name: "고객 이름",
        rate_the_room: "방 평가",
        your_review: "귀하의 리뷰",
        pick_addon_service: "추가 서비스 선택",
        addon_service: {
          service_name: "서비스 이름",
          description: "설명",
          service_type: "서비스 유형",
          charge_type: "요금 유형",
          price: "가격",
          date_applied: "적용 날짜",
        },
      },
      homescreen: {
        check_in: "체크인",
        check_out: "체크아웃",
        adults: "성인",
        children: "어린이",
        promo_code: "프로모션 코드",
        apply: "적용",
        loading: "로드 중...",
        your_bookings: "예약 내역",
        grand_total: "총 금액",
        continue_checkout: "결제 진행",
        open_sidebar: "사이드바 열기",
        add_on_service: "추가 서비스",
        quantity: "수량",
        room_rate: "객실 요금",
        rate_plan: "요금제",
        room: "객실",
        extra_bed: "추가 침대",
        yes: "예",
        no: "아니요",
        total_nights: "총 숙박일수",
        no_of_room: "객실 수",
        view_add_on_services: "추가 서비스 보기",
        extra_bed_fee: "추가 침대 요금",
      },
      filter_room: {
        guests: "투숙객",
        Check_in: "체크인",
        Check_out: "체크아웃",
        adults: "성인",
        children: "어린이",
        children_under_age: "{{age}}세 미만 어린이",
        cancel: "취소",
        save: "저장",
        children_policy: "어린이 정책",
        children_policy_text: `<ul style="padding-left:0;margin-bottom:0;list-style:none;"> <li style="margin-bottom:8px;"> <strong>1–{{childrenFreeAge}}세</strong> 어린이는 무료 숙박. 아기 침대는 요청 시 제공되며, 이용 가능 여부에 따라 다릅니다. </li> <li style="margin-bottom:8px;"> <strong>{{childrenFreeAgePlusOne}}세부터 {{childrenMaxAge}}세까지</strong>의 어린이는 <strong>1박당 {{childrenExtraPrice}} VND</strong>의 추가 요금(조식 포함)으로 엑스트라 베드 제공. 객실당 최대 1개. </li> <li> <strong>{{childrenMaxAgePlusOne}}세 이상</strong>은 성인 요금이 적용됩니다. </li> </ul>`,
        child_age: "{{number_of_children}}명의 어린이 나이",
        years_old: "세",
      },
      footer: {
        legal: "법적 고지",
        help: "도움말",
        cookie_settings: "쿠키 설정",
        terms_of_service: "이용 약관",
        privacy_policy: "개인정보 처리방침",
        support: "지원",
        sign_up: "회원가입",
        sign_in: "로그인",
        contact_us: "문의하기",
        follow_us: "팔로우하기",
        all_rights_reserved: "모든 권리 보유.",
      },
      guest_information: {
        guest_information: "고객 정보",
        title: "고객 세부정보",
        email: "이메일",
        guest_name: "고객 이름",
        email_address: "이메일 주소",
        confirm_email_address: "이메일 확인",
        phone_number: "전화번호",
        confirm_phone_number: "전화번호 확인",
        nationality: "국적",
        special_requests: "특별 요청",
        enter_your_name: "이름을 입력하세요",
        enter_your_email: "이메일을 입력하세요",
        enter_your_phone: "전화번호를 입력하세요",
        confirm_your_email: "이메일을 다시 입력하세요",
        confirm_your_phone: "전화번호를 다시 입력하세요",
        any_special_requests: "특별 요청이 있으신가요?",
        enter_valid_email: "유효한 이메일 주소를 입력하세요.",
        email_must_match: "이메일 주소가 일치해야 합니다.",
        phone_must_match: "전화번호가 일치해야 합니다.",
        select_nationality: "국적을 선택하세요",
        email_confirmation_not_match: "이메일 확인이 일치하지 않습니다.",
        phone_confirmation_not_match: "전화번호 확인이 일치하지 않습니다.",
        require_all_fields: "모든 고객 정보 필드는 필수입니다.",
        no_booking_available:
          "예약 정보가 없습니다. 객실과 요금제를 선택하세요.",
      },
      booking: {
        check_in: "체크인",
        check_out: "체크아웃",
        total_nights: "총 숙박일수",
        your_booking_details: "예약 상세 정보",
        addon_services: "추가 서비스",
        grand_total: "총 금액",
        total_pay: "총 결제 금액 (VND)",
        pay_at_hotel: "호텔에서 결제하실 수 있습니다.",
        secure_type: "결제는 다음으로 안전하게 처리됩니다:",
        confirm_to_leave: "정말로 나가시겠습니까?",
        go_back_discard: "뒤로 가면 예약 정보가 삭제됩니다.",
        confirm_booking: "예, 나가기",
        cancel: "머무르기",
        success_message: "예약이 성공적으로 완료되었습니다",
        success: "성공",
        OK: "확인",
        confirm_policy: "저는 법적 연령임을 확인하며 호텔의",
        term_conditions: "이용 약관에 동의합니다",
        detail: {
          rate_plan: "요금제",
          meal_plan: "식사 계획",
          number_of_rooms: "예약 객실 수",
          adults: "성인",
          children: "어린이",
          total_rate: "총 요금",
          extra_bed_price: "추가 침대 요금",
          cancellation_policy: "취소 정책",
        },
        add_on_service: {
          service_name: "서비스 이름",
          description: "설명",
          service_price: "서비스 가격",
          not_added: "추가 서비스가 선택되지 않았습니다.",
        },
        confirmation: {
          title: "예약 확인",
          booking_id: "예약 ID",
          transaction_id: "거래 ID",
          payment_method: "결제 방법",
          check_in_date: "체크인 날짜",
          check_out_date: "체크아웃 날짜",
          total_nights: "총 숙박일수",
          grand_total: "총 금액",
          email: "이메일",
          policy_service:
            "모든 가격은 5% 서비스 요금과 10% 부가가치세(VAT)가 포함되어 있습니다.",
          scan_booking: "예약 관리 스캔",
          read_rule_hotel: "호텔 규칙 읽기",
          view_on_map: "지도에서 보기",
          download_booking: "예약 다운로드",
          add_to_calendar: "캘린더에 추가",
          thank_you: "저희와 예약해주셔서 감사합니다!",
          room_detail: {
            title: "객실 세부정보",
            number_of_rooms: "객실 수",
            rate_plan: "요금제",
            rate: "요금",
            adults: "성인",
            children: "어린이",
            extra_bed: "추가 침대",
            cancellation_policy: "취소 정책",
            total_extra_bed_price: "추가 침대 총 요금",
            no_data: "객실 정보가 없습니다.",
          },
          rate_breakdown: {
            title: "요금 내역",
            date: "날짜",
            original_rate: "원래 요금",
            promotion: "프로모션",
            promotion_discount: "프로모션 할인",
            promo_code: "프로모션 코드",
            final_rate: "최종 요금",
            no_data: "요금 내역이 없습니다.",
          },
        },
        children_age_policy: {
          title: "어린이 연령 정책",
          description:
            "어린이의 추가 침대 요금은 총 예약 금액에 포함되어 있지 않습니다. 이 요금은 호텔 도착 시 결제하셔야 합니다.",
          extra_bed_price: "추가 침대 요금",
        },
      },
    },
  },
  zh: {
    translation: {
      navbar: {
        homepage: "主页",
        direction: "路线",
        myBooking: "我的预订",
        register: "注册",
        login: "登录",
        profile: "个人资料",
        admin_panel: "管理员面板",
        logout: "退出",
      },
      room: {
        max_adults: "最多成年人",
        max_children: "最多儿童",
        extra_bed: "加床",
        facilities: "设施",
        smoking_policy: "允许吸烟",
        no_smoking: "不允许吸烟",
        view: "视野",
        bedding: "床铺",
        room_size: "房间大小",
        room_type: "房间类型",
        rate_this_room: "评价此房间",
        submit_rating: "提交评价",
        description: "描述",
        average_rating: "平均评分",
        details: "查看详情",
        rate_plan: "价格计划",
        meal_plan: "餐饮计划",
        cancellation_policy: "取消政策",
        pick: "选择",
        add_on_services: "附加服务",
        more_info: "更多信息",
        service_name: "服务名称",
        service_type: "服务类型",
        charge_type: "收费类型",
        price: "价格",
        date_applied: "应用日期",
        close: "关闭",
        validate: "验证",
        booking_id: "预订 ID",
        guest_name: "客人姓名",
        rate_the_room: "评价房间",
        your_review: "您的评论",
        pick_addon_service: "选择附加服务",
        addon_service: {
          service_name: "服务名称",
          description: "描述",
          service_type: "服务类型",
          charge_type: "收费类型",
          price: "价格",
          date_applied: "应用日期",
        },
      },
      homescreen: {
        check_in: "入住日期",
        check_out: "退房日期",
        adults: "成人",
        children: "儿童",
        promo_code: "促销代码",
        apply: "应用",
        loading: "加载中...",
        your_bookings: "您的预订",
        grand_total: "总计",
        continue_checkout: "继续结账",
        open_sidebar: "打开侧边栏",
        add_on_service: "附加服务",
        quantity: "数量",
        room_rate: "房价",
        rate_plan: "价格计划",
        room: "房间",
        extra_bed: "加床",
        yes: "是",
        no: "否",
        total_nights: "总夜数",
        no_of_room: "房间数",
        view_add_on_services: "查看我们的附加服务",
        extra_bed_fee: "加床费用",
      },
      filter_room: {
        guests: "客人数量",
        Check_in: "入住日期",
        Check_out: "退房日期",
        adults: "成人",
        children: "儿童",
        children_under_age: "{{age}}岁以下儿童",
        cancel: "取消",
        save: "保存",
        children_policy: "儿童政策",
        children_policy_text: `<ul style="padding-left:0;margin-bottom:0;list-style:none;"> <li style="margin-bottom:8px;"> <strong>1–{{childrenFreeAge}}岁</strong>的儿童免费入住。婴儿床可根据要求提供，视供应情况而定。 </li> <li style="margin-bottom:8px;"> <strong>{{childrenFreeAgePlusOne}}岁至{{childrenMaxAge}}岁</strong>的儿童可加床，每晚<strong>{{childrenExtraPrice}}越南盾</strong>（含早餐）。每间房最多加一张床。 </li> <li> <strong>{{childrenMaxAgePlusOne}}岁及以上</strong>按成人收费。 </li> </ul>`,
        child_age: "{{number_of_children}}名儿童年龄",
        years_old: "岁",
      },
      footer: {
        legal: "法务信息",
        help: "帮助",
        cookie_settings: "Cookie 设置",
        terms_of_service: "服务条款",
        privacy_policy: "隐私政策",
        support: "支持",
        sign_up: "注册",
        sign_in: "登录",
        contact_us: "联系我们",
        follow_us: "关注我们",
        all_rights_reserved: "版权所有。",
      },
      guest_information: {
        guest_information: "客人信息",
        title: "客人详情",
        email: "电子邮件",
        guest_name: "客人姓名",
        email_address: "电子邮件地址",
        confirm_email_address: "确认电子邮件",
        phone_number: "电话号码",
        confirm_phone_number: "确认电话号码",
        nationality: "国籍",
        special_requests: "特殊要求",
        enter_your_name: "请输入您的姓名",
        enter_your_email: "请输入您的电子邮件",
        enter_your_phone: "请输入您的电话号码",
        confirm_your_email: "请确认您的电子邮件",
        confirm_your_phone: "请确认您的电话号码",
        any_special_requests: "有任何特殊要求吗？",
        enter_valid_email: "请输入有效的电子邮件地址。",
        email_must_match: "电子邮件地址必须匹配。",
        phone_must_match: "电话号码必须匹配。",
        select_nationality: "请选择您的国籍",
        email_confirmation_not_match: "电子邮件确认不匹配。",
        phone_confirmation_not_match: "电话号码确认不匹配。",
        require_all_fields: "所有客人信息字段均为必填项。",
        no_booking_available: "没有可用的预订详情。请选择房间和价格计划。",
      },
      booking: {
        check_in: "入住日期",
        check_out: "退房日期",
        total_nights: "总夜数",
        your_booking_details: "您的预订详情",
        addon_services: "附加服务",
        grand_total: "总计",
        total_pay: "您需支付的总金额 (VND)",
        pay_at_hotel: "您将在酒店付款。",
        secure_type: "您的付款已通过以下方式安全处理：",
        confirm_to_leave: "您确定要离开吗？",
        go_back_discard: "返回将丢失您的预订详情。",
        confirm_booking: "是的，离开",
        cancel: "留下",
        success_message: "您的预订已成功完成",
        success: "成功",
        OK: "确定",
        confirm_policy: "我确认我已达到法定年龄并同意酒店的",
        term_conditions: "条款和条件",
        detail: {
          rate_plan: "价格计划",
          meal_plan: "餐饮计划",
          number_of_rooms: "预订房间数",
          adults: "成人",
          children: "儿童",
          total_rate: "总价",
          extra_bed_price: "加床价格",
          cancellation_policy: "取消政策",
        },
        add_on_service: {
          service_name: "服务名称",
          description: "描述",
          service_price: "服务价格",
          not_added: "未选择附加服务。",
        },
        confirmation: {
          title: "预订确认",
          booking_id: "预订 ID",
          transaction_id: "交易 ID",
          payment_method: "支付方式",
          check_in_date: "入住日期",
          check_out_date: "退房日期",
          total_nights: "总夜数",
          grand_total: "总计",
          email: "电子邮件",
          policy_service: "所有价格均包含5%服务费和10%增值税（VAT）。",
          scan_booking: "扫码管理预订",
          read_rule_hotel: "查看酒店规则",
          view_on_map: "在地图上查看",
          download_booking: "下载预订",
          add_to_calendar: "添加到日历",
          thank_you: "感谢您预订我们的酒店！",
          room_detail: {
            title: "房间详情",
            number_of_rooms: "房间数",
            rate_plan: "价格计划",
            rate: "价格",
            adults: "成人",
            children: "儿童",
            extra_bed: "加床",
            cancellation_policy: "取消政策",
            total_extra_bed_price: "加床总价",
            no_data: "没有房间详情。",
          },
          rate_breakdown: {
            title: "价格明细",
            date: "日期",
            original_rate: "原价",
            promotion: "促销",
            promotion_discount: "促销折扣",
            promo_code: "促销代码",
            final_rate: "最终价格",
            no_data: "没有价格明细。",
          },
        },
        children_age_policy: {
          title: "儿童年龄政策",
          description:
            "儿童加床费用未包含在总预订价格中。此费用需在到店时支付。",
          extra_bed_price: "加床价格",
        },
      },
    },
  },
  ja: {
    translation: {
      navbar: {
        homepage: "ホームページ",
        direction: "道順",
        myBooking: "私の予約",
        register: "登録",
        login: "ログイン",
        profile: "プロフィール",
        admin_panel: "管理パネル",
        logout: "ログアウト",
      },
      room: {
        max_adults: "大人の最大人数",
        max_children: "子供の最大人数",
        extra_bed: "追加ベッド",
        facilities: "施設",
        smoking_policy: "喫煙可",
        no_smoking: "禁煙",
        view: "景色",
        bedding: "寝具",
        room_size: "部屋の広さ",
        room_type: "部屋の種類",
        rate_this_room: "この部屋を評価する",
        submit_rating: "評価を提出する",
        description: "説明",
        average_rating: "平均評価",
        details: "詳細を見る",
        rate_plan: "料金プラン",
        meal_plan: "食事プラン",
        cancellation_policy: "キャンセルポリシー",
        pick: "選ぶ",
        add_on_services: "追加サービス",
        more_info: "詳細情報",
        service_name: "サービス名",
        service_type: "サービスの種類",
        charge_type: "料金の種類",
        price: "価格",
        date_applied: "適用日",
        close: "閉じる",
        validate: "確認",
        booking_id: "予約 ID",
        guest_name: "ゲスト名",
        rate_the_room: "部屋を評価する",
        your_review: "あなたのレビュー",
        pick_addon_service: "追加サービスを選択",
        addon_service: {
          service_name: "サービス名",
          description: "説明",
          service_type: "サービスの種類",
          charge_type: "料金の種類",
          price: "価格",
          date_applied: "適用日",
        },
      },
      homescreen: {
        check_in: "チェックイン",
        check_out: "チェックアウト",
        adults: "大人",
        children: "子供",
        promo_code: "プロモーションコード",
        apply: "適用",
        loading: "読み込み中...",
        your_bookings: "予約内容",
        grand_total: "合計金額",
        continue_checkout: "チェックアウトを続ける",
        open_sidebar: "サイドバーを開く",
        add_on_service: "追加サービス",
        quantity: "数量",
        room_rate: "部屋料金",
        rate_plan: "料金プラン",
        room: "部屋",
        extra_bed: "エキストラベッド",
        yes: "はい",
        no: "いいえ",
        total_nights: "宿泊合計日数",
        no_of_room: "部屋数",
        view_add_on_services: "追加サービスを見る",
        extra_bed_fee: "エキストラベッド料金",
      },
      filter_room: {
        guests: "宿泊者数",
        Check_in: "チェックイン",
        Check_out: "チェックアウト",
        adults: "大人",
        children: "子供",
        children_under_age: "{{age}}歳未満の子供",
        cancel: "キャンセル",
        save: "保存",
        children_policy: "子供のポリシー",
        children_policy_text: `<ul style="padding-left:0;margin-bottom:0;list-style:none;"> <li style="margin-bottom:8px;"> <strong>1～{{childrenFreeAge}}歳</strong>の子供は無料で宿泊できます。ベビーベッドはリクエスト制で、空き状況によります。 </li> <li style="margin-bottom:8px;"> <strong>{{childrenFreeAgePlusOne}}歳から{{childrenMaxAge}}歳</strong>の子供は、1泊<strong>{{childrenExtraPrice}} VND</strong>（朝食付き）でエキストラベッド利用可。1部屋につき最大1台。 </li> <li> <strong>{{childrenMaxAgePlusOne}}歳以上</strong>は大人と同料金です。 </li> </ul>`,
        child_age: "{{number_of_children}}人の子供の年齢",
        years_old: "歳",
      },
      footer: {
        legal: "法的情報",
        help: "ヘルプ",
        cookie_settings: "クッキー設定",
        terms_of_service: "利用規約",
        privacy_policy: "プライバシーポリシー",
        support: "サポート",
        sign_up: "サインアップ",
        sign_in: "サインイン",
        contact_us: "お問い合わせ",
        follow_us: "フォローする",
        all_rights_reserved: "全著作権所有。",
      },
      guest_information: {
        guest_information: "ゲスト情報",
        title: "ゲスト詳細",
        email: "メール",
        guest_name: "ゲスト名",
        email_address: "メールアドレス",
        confirm_email_address: "メールアドレス確認",
        phone_number: "電話番号",
        confirm_phone_number: "電話番号確認",
        nationality: "国籍",
        special_requests: "特別なリクエスト",
        enter_your_name: "お名前を入力してください",
        enter_your_email: "メールアドレスを入力してください",
        enter_your_phone: "電話番号を入力してください",
        confirm_your_email: "メールアドレスを再入力してください",
        confirm_your_phone: "電話番号を再入力してください",
        any_special_requests: "特別なリクエストはありますか？",
        enter_valid_email: "有効なメールアドレスを入力してください。",
        email_must_match: "メールアドレスが一致する必要があります。",
        phone_must_match: "電話番号が一致する必要があります。",
        select_nationality: "国籍を選択してください",
        email_confirmation_not_match: "メールアドレスの確認が一致しません。",
        phone_confirmation_not_match: "電話番号の確認が一致しません。",
        require_all_fields: "すべてのゲスト情報は必須です。",
        no_booking_available:
          "予約詳細がありません。部屋と料金プランを選択してください。",
      },
      booking: {
        check_in: "チェックイン",
        check_out: "チェックアウト",
        total_nights: "合計宿泊数",
        your_booking_details: "ご予約内容",
        addon_services: "追加サービス",
        grand_total: "合計金額",
        total_pay: "お支払い総額 (VND)",
        pay_at_hotel: "ホテルでお支払いください。",
        secure_type: "お支払いは次で安全に処理されます：",
        confirm_to_leave: "本当に離れますか？",
        go_back_discard: "戻ると予約内容が破棄されます。",
        confirm_booking: "はい、離れる",
        cancel: "滞在する",
        success_message: "ご予約が正常に完了しました",
        success: "成功",
        OK: "OK",
        confirm_policy: "私は法定年齢であり、ホテルの",
        term_conditions: "利用規約に同意します",
        detail: {
          rate_plan: "料金プラン",
          meal_plan: "食事プラン",
          number_of_rooms: "予約部屋数",
          adults: "大人",
          children: "子供",
          total_rate: "合計料金",
          extra_bed_price: "エキストラベッド料金",
          cancellation_policy: "キャンセルポリシー",
        },
        add_on_service: {
          service_name: "サービス名",
          description: "説明",
          service_price: "サービス料金",
          not_added: "追加サービスが選択されていません。",
        },
        confirmation: {
          title: "予約確認",
          booking_id: "予約 ID",
          transaction_id: "取引 ID",
          payment_method: "支払い方法",
          check_in_date: "チェックイン日",
          check_out_date: "チェックアウト日",
          total_nights: "合計宿泊数",
          grand_total: "合計金額",
          email: "メール",
          policy_service:
            "すべての料金には5％のサービス料と10％の消費税（VAT）が含まれています。",
          scan_booking: "予約管理をスキャン",
          read_rule_hotel: "ホテルのルールを読む",
          view_on_map: "地図で見る",
          download_booking: "予約をダウンロード",
          add_to_calendar: "カレンダーに追加",
          thank_you: "ご予約いただきありがとうございます！",
          room_detail: {
            title: "部屋の詳細",
            number_of_rooms: "部屋数",
            rate_plan: "料金プラン",
            rate: "料金",
            adults: "大人",
            children: "子供",
            extra_bed: "エキストラベッド",
            cancellation_policy: "キャンセルポリシー",
            total_extra_bed_price: "エキストラベッド合計料金",
            no_data: "部屋の詳細がありません。",
          },
          rate_breakdown: {
            title: "料金内訳",
            date: "日付",
            original_rate: "元の料金",
            promotion: "プロモーション",
            promotion_discount: "プロモーション割引",
            promo_code: "プロモーションコード",
            final_rate: "最終料金",
            no_data: "料金内訳がありません。",
          },
        },
        children_age_policy: {
          title: "お子様の年齢ポリシー",
          description:
            "お子様のエキストラベッド料金はご予約合計金額に含まれておりません。この料金はホテル到着時にお支払いください。",
          extra_bed_price: "エキストラベッド料金",
        },
      },
    },
  },
};

// Initialize i18n
i18n
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    resources,
    lng: "en", // Set default language
    fallbackLng: "en", // Fallback language
    interpolation: {
      escapeValue: false, // React already escapes by default
    },
  });

export default i18n;
